import { render } from "./EditBonus.vue?vue&type=template&id=33dfc868&scoped=true"
import script from "./EditBonus.vue?vue&type=script&lang=js"
export * from "./EditBonus.vue?vue&type=script&lang=js"

import "./EditBonus.vue?vue&type=style&index=0&id=33dfc868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dfc868"]])

export default __exports__